import { useCallback, useRef } from 'react'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import * as Dropdown from '@radix-ui/react-dropdown-menu'

import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import SvgBoldMoreHorisontal from '@jotta/ui/SvgBoldMoreHorisontal'

import styles from './CommentActions.module.scss'

export const CommentActions: React.FC<{
  ownerUsername: string
  loginUsername?: string
  id: string
  contextKey: string
  onEdit?: (contextKey: string, commentId: string) => void
  onDelete?: (contextKey: string, commentId: string) => void
}> = ({
  ownerUsername,
  loginUsername = '',
  id,
  contextKey,
  onEdit,
  onDelete,
}) => {
  const timestamp = useRef(0)

  const onOpenChange = useCallback((open: boolean) => {
    if (open) {
      timestamp.current = new Date().valueOf()
    }
  }, [])

  const onSelectWrapper = useCallback(
    (cb: (e: Event) => void) => (e: Event) => {
      if (new Date().valueOf() - timestamp.current >= 300) {
        cb(e)
      } else {
        e.preventDefault()
      }
    },
    [],
  )

  const editClick = onSelectWrapper(
    useCallback(() => {
      if (onEdit) {
        onEdit(contextKey, id)
      }
    }, [onEdit, contextKey, id]),
  )

  const deleteClick = onSelectWrapper(
    useCallback(() => {
      if (onDelete) {
        onDelete(contextKey, id)
      }
    }, [onDelete, contextKey, id]),
  )

  if (ownerUsername !== loginUsername) {
    return null
  }

  return (
    <Dropdown.Root onOpenChange={onOpenChange}>
      <Dropdown.Trigger className={styles.dropdownTrigger}>
        <PlainBrandIcon icon={SvgBoldMoreHorisontal} />
      </Dropdown.Trigger>
      <Dropdown.Content
        align="center"
        sideOffset={16}
        collisionPadding={30}
        className={styles.dropdown}
      >
        {ownerUsername && loginUsername === ownerUsername && (
          <Dropdown.Item className={styles.dropdownItem} onSelect={editClick}>
            <Trans>Edit</Trans>
          </Dropdown.Item>
        )}
        {ownerUsername && loginUsername === ownerUsername && (
          <Dropdown.Item className={styles.dropdownItem} onSelect={deleteClick}>
            <Trans>Delete</Trans>
          </Dropdown.Item>
        )}
      </Dropdown.Content>
    </Dropdown.Root>
  )
}
